<div class="c-empty">
  <div class="row">
    <div class="col-12">
      <img :src="require('@/assets/icons/sidebars/empty.svg')" alt="" />
    </div>
  </div>
  <div class="c-empty-title">
    <span class="name">{{ $t('errorEmpty') }}</span>
    <span class="desc">{{ $t('errorEmptyMessage') }}</span>
  </div>
</div>
